import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VideoDetailsDialogComponent } from './video-details-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		VideoDetailsDialogComponent
	],
	exports: [
		VideoDetailsDialogComponent
	]
})
export class VideoDetailsDialogModule {}
